// Which edge(s) of each SmallCard variation's line art never touch the
// frame — lets a caller flip the artwork (via SmallCardTonalSplash's
// `contentSide` prop) so its clear edge faces wherever their overlaid
// content sits, instead of the content colliding with a line. Eyeballed
// against the processed SVGs in src/assets/illustrations/small-card-*.svg.
export const SMALL_CARD_SAFE_EDGES = {
  A: [],                    // no safe edge — needs a curve polish pass (weird bump)
  B: ['left'],
  C: ['right'],
  D: ['right'],
  // Corrected 2026-08-07 (was ['top','bottom'] — wrong; confirmed against
  // the real path geometry, not just eyeballing): the spiral shape's tail
  // runs to y=272.2 in a 272-tall viewBox, right at/past the bottom edge.
  // Only 'top' has real clearance (nearest path minimum y=16.3, well clear
  // of y=0).
  E: ['top'],
  F: ['left'],
}

export const SMALL_CARD_VARIATIONS = Object.keys(SMALL_CARD_SAFE_EDGES)
